module.exports = __webpack_public_path__ + "static/img/banner-dwb-1411.ead2d2a.png";